










































































import type { Story } from "@constructor/shared-entity/type";
import { defineComponent } from "vue-demi";
import GGLink from "../../../global/GGLink.vue";

export default defineComponent({
  name: "MPStories",
  components: {
    GGLink,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    interval: {
      type: Number,
      default: 10000,
    },
    initialIndex: {
      type: Number,
      default: 0,
    },
    stories: {
      type: Array<Story>,
      default: [],
    },
  },
  emits: ["close"],
  data() {
    return {
      activeStoryIndex: this.initialIndex,
      startedAt: 0,
      timeoutId: null as NodeJS.Timer | null,
      isPaused: false,
      pausedAt: 0,
      timeDuration: 0,
      holdTimeout: null as NodeJS.Timer | null,
      longTouch: false,
      videoDuration: 0,
    };
  },
  computed: {
    activeStory() {
      return this.$props.stories[this.$data.activeStoryIndex];
    },
    isVideo(): boolean {
      if (!this.activeStory.image?.x1) {
        return false;
      } else {
        return /\.(mp4|mov|avi|mkv|webm)(\?.*)?$/i.test(
          this.activeStory.image?.x1
        );
      }
    },
    timeFillStyle() {
      return {
        animationDuration: `${
          this.isVideo && this.videoDuration
            ? this.videoDuration
            : this.interval / 1000
        }s`,
      };
    },
  },
  watch: {
    active(newValue: boolean) {
      if (newValue) {
        this.activeStoryIndex = this.initialIndex;
        this.play();
      } else {
        this.clearTimers();
      }
    },
    isPaused(newVal: boolean) {
      const video = this.$refs.video as HTMLVideoElement | undefined;
      if (video) {
        newVal ? video.pause() : video.play().catch(() => {});
      }
    },
  },
  methods: {
    playStory() {
      if (!this.isPaused) return;
      this.isPaused = false;
      this.startedAt = new Date().getTime();
      this.clearTimers();
      this.timeDuration = this.isVideo
        ? this.videoDuration * 1000
        : this.interval - this.pausedAt;
      this.timeoutId = setTimeout(() => {
        this.nextStory();
      }, this.timeDuration);
    },
    pauseStory() {
      if (this.isPaused) return;
      this.isPaused = true;
      this.pausedAt = new Date().getTime() - this.startedAt;
      this.clearTimers();
    },
    play() {
      if (this.isVideo && !this.videoDuration) {
        this.isPaused = true;
        return;
      }

      this.isPaused = false;
      this.startedAt = new Date().getTime();
      this.timeDuration = this.isVideo
        ? this.videoDuration * 1000
        : this.interval;

      this.clearTimers();

      this.timeoutId = setTimeout(() => {
        this.nextStory();
      }, this.timeDuration);
    },
    nextStory() {
      if (this.activeStoryIndex < this.stories.length - 1) {
        this.pausedAt = 0;
        this.activeStoryIndex++;
        this.play();
      } else {
        this.$emit("close");
      }
    },
    prevStory() {
      if (this.activeStoryIndex > 0) {
        this.activeStoryIndex--;
        this.pausedAt = 0;
        this.play();
      }
    },
    clearTimers() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
    handleTouchStart() {
      this.holdTimeout = setTimeout(() => {
        this.longTouch = true;
        this.pauseStory();
      }, 200);
    },
    handleTouchEnd(event: TouchEvent | MouseEvent) {
      if (this.holdTimeout) {
        clearTimeout(this.holdTimeout);
        this.holdTimeout = null;
      }

      if (this.longTouch) {
        this.playStory();
      } else {
        let clickX;
        let overlayWidth;

        if (event instanceof TouchEvent && event.changedTouches.length > 0) {
          clickX = event.changedTouches[0].clientX;
          overlayWidth = (this.$refs.story as HTMLDivElement | undefined)
            ?.clientWidth;
        } else if (event instanceof MouseEvent) {
          clickX = event.clientX;
          overlayWidth = window.innerWidth;
        }

        if (overlayWidth && clickX) {
          const isLeftSide = clickX < overlayWidth / 2;
          if (isLeftSide) {
            this.activeStoryIndex !== 0 ? this.prevStory() : this.play();
          } else {
            this.nextStory();
          }
        }
      }

      this.longTouch = false;
    },
    onVideoLoaded(event: Event) {
      const video = event.target as HTMLVideoElement;
      this.videoDuration = video.duration;
      this.play();
    },
  },
  onBeforeUnmount() {
    this.clearTimers();
  },
});
